import numeral from 'numeral';

const negativeScientificBreakpoint = 10 ** -6;
const positiveScientificBreakpoint = 10 ** 20;

export default {
  getNumeralFormat(value, numeralFormat) {
    const parsedValue = Number(value);

    if (Number.isNaN(parsedValue)) {
      console.warn('Could not parse value, the result is NaN');
      return null;
    }

    if (parsedValue > positiveScientificBreakpoint) {
      console.warn('Could not parse value, the result is over 1e+20');
      return Infinity;
    } else if (parsedValue < -positiveScientificBreakpoint) {
      console.warn('Could not parse value, the result is over -1e+20');
      return -Infinity;
    }

    if (parsedValue !== 0 && parsedValue > -negativeScientificBreakpoint && parsedValue < negativeScientificBreakpoint) {
      console.warn('Could not parse value, the result is smaller 1e-7, and is parsed to "0" ');
      return 0;
    }

    return numeral(parsedValue).format(numeralFormat);
  },
};
